/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Cognito API
 * Bank Relationship Management - Cognito
 * OpenAPI spec version: v1
 */
import type {
  GetApiV1CurrencySpotQuotesConsolidated200,
  GetApiV1CurrencySpotQuotesConsolidatedParams,
  GetApiV1CurrencySpotQuotesHistory200,
  GetApiV1CurrencySpotQuotesHistoryParams,
  GetApiV1CurrencySpotQuotesHistoryRange200,
  GetApiV1CurrencySpotQuotesHistoryRangeParams,
  GetApiV1CurrencySpotQuotesLatest200,
  GetApiV1CurrencySpotQuotesLatestParams,
  GetApiV1CurrencySpotQuotesPairs200,
  GetApiV1CurrencySpotQuotesReferences200,
  GetApiV1CurrencySpotQuotesReferencesParams
} from '../schemas';

import { customInstance } from '.././mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getCurrencySpotQuote = () => {
/**
 * @summary Retorna os pares de moeda suportados.
 */
const getCurrencySpotQuotesPairs = (

 options?: SecondParameter<typeof customInstance<GetApiV1CurrencySpotQuotesPairs200>>,) => {
      return customInstance<GetApiV1CurrencySpotQuotesPairs200>(
      {url: `/api/v1/currency-spot-quotes/pairs`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Retorna a cotação diária mais recente por par.
 */
const getCurrencySpotQuotesLatest = (
    params?: GetApiV1CurrencySpotQuotesLatestParams,
 options?: SecondParameter<typeof customInstance<GetApiV1CurrencySpotQuotesLatest200>>,) => {
      return customInstance<GetApiV1CurrencySpotQuotesLatest200>(
      {url: `/api/v1/currency-spot-quotes/latest`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Retorna o histórico de cotações diárias disponíveis (janela de até 8 dias) por par.
 */
const getCurrencySpotQuotesHistory = (
    params?: GetApiV1CurrencySpotQuotesHistoryParams,
 options?: SecondParameter<typeof customInstance<GetApiV1CurrencySpotQuotesHistory200>>,) => {
      return customInstance<GetApiV1CurrencySpotQuotesHistory200>(
      {url: `/api/v1/currency-spot-quotes/history`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Retorna o histórico de cotações diárias dentro de um intervalo de datas arbitrário (até 90 dias).
Diferente de `/history`, que só olha de hoje para trás, este endpoint serve para
reconstruir o contexto de mercado em torno de uma data passada — por exemplo, os 7 dias
anteriores a um disparo de alerta histórico.
 */
const getCurrencySpotQuotesHistoryRange = (
    params?: GetApiV1CurrencySpotQuotesHistoryRangeParams,
 options?: SecondParameter<typeof customInstance<GetApiV1CurrencySpotQuotesHistoryRange200>>,) => {
      return customInstance<GetApiV1CurrencySpotQuotesHistoryRange200>(
      {url: `/api/v1/currency-spot-quotes/history/range`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Retorna as âncoras de referência (PreviousDay, StartOfYear, TwelveMonthsAgo) por par.
 */
const getCurrencySpotQuotesReferences = (
    params?: GetApiV1CurrencySpotQuotesReferencesParams,
 options?: SecondParameter<typeof customInstance<GetApiV1CurrencySpotQuotesReferences200>>,) => {
      return customInstance<GetApiV1CurrencySpotQuotesReferences200>(
      {url: `/api/v1/currency-spot-quotes/references`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Retorna cotação mais recente, âncoras de referência e opcionalmente histórico diário por par.
 */
const getCurrencySpotQuotesConsolidated = (
    params?: GetApiV1CurrencySpotQuotesConsolidatedParams,
 options?: SecondParameter<typeof customInstance<GetApiV1CurrencySpotQuotesConsolidated200>>,) => {
      return customInstance<GetApiV1CurrencySpotQuotesConsolidated200>(
      {url: `/api/v1/currency-spot-quotes/consolidated`, method: 'GET',
        params
    },
      options);
    }
  return {getCurrencySpotQuotesPairs,getCurrencySpotQuotesLatest,getCurrencySpotQuotesHistory,getCurrencySpotQuotesHistoryRange,getCurrencySpotQuotesReferences,getCurrencySpotQuotesConsolidated}};
export type GetApiV1CurrencySpotQuotesPairsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCurrencySpotQuote>['getCurrencySpotQuotesPairs']>>>
export type GetApiV1CurrencySpotQuotesLatestResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCurrencySpotQuote>['getCurrencySpotQuotesLatest']>>>
export type GetApiV1CurrencySpotQuotesHistoryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCurrencySpotQuote>['getCurrencySpotQuotesHistory']>>>
export type GetApiV1CurrencySpotQuotesHistoryRangeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCurrencySpotQuote>['getCurrencySpotQuotesHistoryRange']>>>
export type GetApiV1CurrencySpotQuotesReferencesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCurrencySpotQuote>['getCurrencySpotQuotesReferences']>>>
export type GetApiV1CurrencySpotQuotesConsolidatedResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCurrencySpotQuote>['getCurrencySpotQuotesConsolidated']>>>
